import React from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; 



const Faqs = () => {
  const faqs = [
    {
      question: "What is Evventoz?",
      answer:
        "Evventoz is a comprehensive event management platform that allows users to create, manage, promote, and sell tickets for events. It supports both in-person and virtual events.",
    },
    {
      question: "How do I sign up for an Evventoz account?",
      answer:
        "Visit www.evventoz.com, click on 'Sign Up,' and fill in your details. You can also sign up using Google or Facebook for faster access.",
    },
    {
      question: "Is Evventoz free to use?",
      answer:
        " Creating an account and listing free events is free. For paid events, Evventoz charges a small service fee per ticket sold.",
    },
    {
      question: "How do I create a new event on Evventoz?",
      answer:
        "Once logged in, click on 'Create Event' from your dashboard. Fill in your event details, set ticket types, and publish when ready.",
    },

    {
      question: "Can I edit my event after it's been published? ",
      answer:
        " Yes, you can edit most event details from the 'My Events' section, including event name, time, and ticket options.",
    },

    {
      question: "Can I duplicate a previous event? ",
      answer:
        " Absolutely. Go to your 'Past Events, click on the event, and select “Duplicate Event” to reuse its setup.",
    },


    {
      question: " How do I set different ticket types (e.g., Early Bird, VIP)?",
      answer:
        " While creating or editing your event, go to the “Tickets” tab. Add multiple ticket types with custom pricing and availability dates.",
    },


    {
      question: "What payment methods are accepted on Evventoz? ",
      answer:
        " We accept major credit/debit cards, UPI Payments, Netbanking etc, and local payment options depending on your region.",
    },

    {
      question: "When do I receive the payouts from ticket sales? ",
      answer:
        " Payouts are processed within 3–5 business days after your event concludes, depending on your payment setup. Also payouts settling on weekly basis is possible based on the paid subscription that you take as a Organiser",
    },

    {
      question: " How do I contact attendees who bought tickets?",
      answer:
        "Navigate to your event dashboard, click on “Attendees,” and you’ll have options to email individuals or send a mass update. ",
    },


    {
      question: "What if an attendee wants a refund? ",
      answer:
        "You can manage refunds from the “Orders” section. You can issue full or partial refunds based on your event’s refund policy. Refunds are also subject to which parties are collecting Tickets payments. ",
    },


    {
      question: "Can I export the attendee list?   ",
      answer:
        "Yes, go to your event’s “Attendee” tab and click “Export CSV” to download the full list. ",
    },


    {
      question: " Is my data secure on Evventoz?",
      answer:
        "Yes, we use industry-standard encryption and secure payment gateways to protect user data and transactions.",
    },

    {
      question: "What should I do if I'm having technical issues? ",
      answer:
        " Please contact our support team via the 'Help Center' or email support@evventoz.com. Live chat is also available during business hours.",
    },

    {
      question: "Can I add my branding to the event page? ",
      answer:
        "Yes! Under the “Event Settings,” you can upload your logo, customize color themes, and add branded banners. ",
    },

    {
      question: "Does Evventoz support virtual events? ",
      answer:
        "Absolutely. You can link to Zoom, YouTube, or any live stream. We also offer integrated video conferencing for premium plans. ",
    },


  ];

  return (
    <>
      <NavbarVisitor />
      <section className="faq-section py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4 display-5 text-primary">Frequently Asked Questions</h2>
          <p className="text-center mb-5 text-muted">
            Find answers to the most commonly asked questions below.
          </p>

          <Accordion defaultActiveKey="0" className="text-start">
            {faqs.map((faq, index) => (
              <Accordion.Item eventKey={index.toString()} key={index} className="mb-3 shadow-sm border-0 rounded-3">
                <Accordion.Header>{faq.question}</Accordion.Header>
                <Accordion.Body>{faq.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Faqs;
